import { DATE_FILTER_STRING_FORMAT, DATE_TIME_FILTER_STRING_FORMAT } from '@doss/common-all'
import { GridFilterInputValueProps } from '@mui/x-data-grid-premium'
import dayjs from 'dayjs'
import { DatePicker } from '~/@/components/inputs/date/date-picker/date-picker'

type SingleDateFilterInputProps = GridFilterInputValueProps & {
  withTime: boolean
  disabled: boolean
}

/**
 * Wrapper component for SingleDatePicker to handle MUI Grid props
 */
export function SingleDateFilterInput(props: SingleDateFilterInputProps) {
  const { item, applyValue, withTime, disabled } = props

  return (
    <DatePicker
      disabled={disabled}
      onChange={(newValue) => {
        if (dayjs.isDayjs(newValue) && newValue.isValid()) {
          // For date filters, format date as YYYY-MM-DD
          /// For date time filters, format date as YYYY-MM-DDTHH:mm
          const value = withTime
            ? newValue.format(DATE_TIME_FILTER_STRING_FORMAT)
            : newValue.format(DATE_FILTER_STRING_FORMAT)
          applyValue({ ...item, value })
        }
      }}
      value={item.value ? dayjs(item.value) : undefined}
      withTime={withTime}
    />
  )
}
